<template>
  <div :id="id" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal m-3 m-md-4" style="background: rgba(25, 25, 25, 0.9); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); border: 1px solid rgba(255,255,255,0.1); border-radius: 20px; box-shadow: 0 10px 40px rgba(0,0,0,0.5); position: relative;">
        <!-- Close Icon -->
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="hide" style="position: absolute; right: 16px; top: 16px; z-index: 10; opacity: 0.6; text-shadow: none; outline: none; background: transparent; border: none;">
          <span aria-hidden="true" style="font-size: 24px;">&times;</span>
        </button>

        <div class="modal-body p-4 p-md-5">
          
          <h4 class="font-size-22 text-white font-weight-bold mb-4 text-center">Edit Expiry Date</h4>
          
          <div v-if="localCard" class="mb-4">
            <div class="d-flex align-items-center justify-content-center mb-4">
              <i class="fa fa-credit-card font-size-24 text-muted mr-3"></i>
              <span class="text-white font-weight-bold" style="font-size: 18px; letter-spacing: 2px;">**** **** **** {{ localCard.last4Digit }}</span>
            </div>

            <div class="row">
              <div class="col-10 col-md-8 mx-auto">
                <label class="text-muted font-size-12 text-uppercase font-weight-bold d-block text-center" style="letter-spacing: 1px;">Expiry Date <span class="text-danger">*</span></label>
                <div class="d-flex justify-content-center" style="gap: 8px;">
                  <div class="position-relative w-50">
                    <select class="form-control" v-model="localCard.expMonth" style="background: rgba(0,0,0,0.3) !important; border: 1px solid rgba(255,255,255,0.1) !important; color: white !important; border-radius: 12px; height: 50px; appearance: none; padding: 0 15px;">
                      <option value="" disabled style="color: black;">MM</option>
                      <option v-for="m in 12" :key="m" :value="m < 10 ? '0'+m : m.toString()" style="color: black;">
                        {{ m < 10 ? '0'+m : m }}
                      </option>
                    </select>
                    <i class="fa fa-chevron-down position-absolute text-muted" style="right: 15px; top: 18px; pointer-events: none; font-size: 14px;"></i>
                  </div>
                  <span class="text-white d-flex align-items-center" style="font-size: 20px;">/</span>
                  <div class="position-relative w-50">
                    <select class="form-control" v-model="localCard.expYear" style="background: rgba(0,0,0,0.3) !important; border: 1px solid rgba(255,255,255,0.1) !important; color: white !important; border-radius: 12px; height: 50px; appearance: none; padding: 0 15px;">
                      <option value="" disabled style="color: black;">YY</option>
                      <option v-for="y in 15" :key="y" :value="(currentYear + y - 1).toString()" style="color: black;">
                        {{ (currentYear + y - 1).toString().slice(2) }}
                      </option>
                    </select>
                    <i class="fa fa-chevron-down position-absolute text-muted" style="right: 15px; top: 18px; pointer-events: none; font-size: 14px;"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="d-flex justify-content-center mt-4">
            <button type="button" @click="save"
                    class="btn btn-premium px-5 font-weight-bold border-0 font-size-16"
                    style="border-radius: 12px; height: 48px; min-width: 160px; letter-spacing: 1px;"
                    :disabled="isLoading">
              <i v-if="isLoading" class="fa fa-spinner fa-spin mr-2"></i>
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelEditCard",
  props: {
    id: {
      type: String,
      default: 'edit_card_modal'
    },
    card: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localCard: null,
      currentYear: new Date().getFullYear()
    }
  },
  watch: {
    card: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.localCard = JSON.parse(JSON.stringify(newVal));
          if (this.localCard.expMonth && this.localCard.expMonth.toString().length === 1) {
             this.localCard.expMonth = '0' + this.localCard.expMonth;
          }
        }
      }
    }
  },
  methods: {
    show() {
      $(`#${this.id}`).modal('show');
    },
    hide() {
      $(`#${this.id}`).modal('hide');
    },
    save() {
      this.$emit('save', this.localCard);
    }
  }
}
</script>

<style scoped>
.btn-premium {
  background: linear-gradient(135deg, #ff6ec7, #f9a826);
  color: #fff !important;
  transition: all 0.2s ease;
}
.btn-premium:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 110, 199, 0.4);
}
.form-control:focus {
  box-shadow: none;
  border-color: #ff6ec7;
}
</style>
